export enum ShowTypeError {
    TEXT = 1,
    TOAST = 2
}
